import { useMemo } from "react";
import ReactJson from "react-json-view";
import { useCopyToClipboard } from "../../../hooks/useCopyToClipboard";

export default function JsonPrettyViewer(props) {

    const { dataString, title, collapsed, name = "root", } = props;

    // Parse input safely; keep both original and pretty string for copying
    const { data, pretty } = useMemo(() => {
        let parsed = null;
        let prettyStr = "";
        if (typeof dataString === "string") {
            try {
                parsed = JSON.parse(dataString);
                prettyStr = JSON.stringify(parsed, null, 2);
            } catch {
                // If not valid JSON string, show as plain text
                parsed = { __invalidJsonString__: dataString };
                prettyStr = dataString;
            }
        } else {
            parsed = dataString ?? null;
            try {
                prettyStr = JSON.stringify(parsed, null, 2);
            } catch {
                prettyStr = String(parsed);
            }
        }
        return { data: parsed, pretty: prettyStr };
    }, [dataString]);
    // Reusable copy hook
    const { copied, copy, ManualCopyUI } = useCopyToClipboard(pretty);

    return (
        <div className="flex felx-col">
            <div className="flex flex-row felx-start gap-2">
                <h1 style={{ fontSize: '1.3rem' }}>{title}</h1>
                <button
                    onClick={copy}
                    className="btn"
                    style={{
                        background: "#1e4e9c",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        padding: "5px 5px",
                        cursor: "pointer",
                        height: "2.5rem",
                    }}
                >
                    {copied ? "Copied!" : "Copy"}
                </button>
            </div>
            <ReactJson
                src={data ?? null}
                name={name}
                //theme={theme}
                collapsed={collapsed}
                enableClipboard={true}
                displayDataTypes={false}
                displayObjectSize={true}
                collapseStringsAfterLength={120}
            // shouldCollapse={(field) => {
            //     // You can add custom collapse logic per node here if needed.
            //     return false;
            // }}
            // style={{
            //     border: "1px solid #ddd",
            //     borderRadius: 6,
            //     padding: 10,
            // }}
            />
            {/* Manual fallback UI if needed */}
            {ManualCopyUI}
        </div>
    );
}
